// eslint-disable-next-line no-shadow
export enum RouteEnum {
    connexion = 'connexion',
    otpConnexion = 'connexion/otp',
    dashboard = 'espace-client/tableau-de-bord',
    forgotLogin = 'identifiant-oublie',
    activation = 'activation',
    tokenBasculeMobile = 'bsc/:primaryProvider/:secondaryProvider/:tokenBasculeMobile',
    reinitialisation = 'reinitialisation',
    consentement = 'souscription/parcours-medical/consentements',
    qss = 'souscription/parcours-medical/questionnaire-de-sante-simplifie',
    qs = 'souscription/parcours-medical/questionnaire-de-sante',
    signature = 'souscription/signature',
    documentWaiting = 'souscription/document-medicale/en-attente',
    documentLoading = 'souscription/document-medicale/chargement',
    documentSelectionType = 'souscription/document-medicale/document-selection-type',
    finalisation = 'souscription/finalisation',
    differedDecisionIntroduction = 'souscription/document-medicale/differed-decision-introduction',
    documentList = 'souscription/document-medicale/document-list',
    recap = 'souscription/document-medicale/recap',
    nextStepIntroduction = 'souscription/document-medicale/next-step-introduction',
    appointmentDetails = 'souscription/appointment-details',
    appointmentPlanner = 'souscription/appointment/appointment-planner',
    appointmentModify = 'souscription/appointment/appointment-details',
    pageNotFound = '404',
}
